import { render, staticRenderFns } from "./week_notes.vue?vue&type=template&id=7546dfc2&scoped=true&"
import script from "./week_notes.vue?vue&type=script&lang=js&"
export * from "./week_notes.vue?vue&type=script&lang=js&"
import style0 from "./week_notes.vue?vue&type=style&index=0&id=7546dfc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7546dfc2",
  null
  
)

export default component.exports